const menuBtn = document.querySelector('.hamburger-label');
const menuInput = document.getElementById('checkbox_toggle');
const rolexMenu = document.querySelector('.rolex-menu');

function toggleMenu() {
  if (rolexMenu.style.display === 'block') {
    rolexMenu.style.display = 'none';
    document.querySelector('.hamburger').style.transform = 'rotate(0deg)';
  } else {
    rolexMenu.style.display = 'block';
    document.querySelector('.hamburger').style.transform = 'rotate(-180deg)';
  }
}

menuBtn.addEventListener('click', toggleMenu);
menuInput.addEventListener('change', toggleMenu);

const setNavPosition = () => {
  const rolexNavBarHeight = document.querySelectorAll('.rolex-top-nav');
  let rolexMenuItemsHeights = 0;

  rolexNavBarHeight.forEach(element => {
    rolexMenuItemsHeights += element.offsetHeight;
  });
  console.log(rolexMenuItemsHeights);

  document.documentElement.style.setProperty('--rolex-menu-items-heights', rolexMenuItemsHeights + 'px');
  console.log('resized');
};

setNavPosition();
window.addEventListener('resize', setNavPosition);